import { render, staticRenderFns } from "./legendBox1.vue?vue&type=template&id=622f1974&scoped=true&"
import script from "./legendBox1.vue?vue&type=script&lang=js&"
export * from "./legendBox1.vue?vue&type=script&lang=js&"
import style0 from "./legendBox1.vue?vue&type=style&index=0&id=622f1974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f1974",
  null
  
)

export default component.exports